export default __webpack_public_path__ + "static/media/Chrysler.e13ef9ea.svg";